import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ProviderPatientsUIHelpers";

const ProviderPatientsUIContext = createContext();

export function useProviderPatientsUIContext() {
  return useContext(ProviderPatientsUIContext);
}

export const ProviderPatientsUIConsumer = ProviderPatientsUIContext.Consumer;

export function ProviderPatientsUIProvider({ ProviderPatientsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams, 
    openDetailProviderAppointmentPage: ProviderPatientsUIEvents.openDetailProviderAppointmentPage
  };

  return (
    <ProviderPatientsUIContext.Provider value={value}>
      {children}
    </ProviderPatientsUIContext.Provider>
  );
}
